module.exports = __webpack_public_path__ + "static/media/businessriver.6bb40414.jpg";